import { cn } from '../../lib/utils';

const STATUS_STYLES = {
  not_started: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
  in_progress: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  completed: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
  failed: 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  expired: 'bg-slate-100 text-slate-400 line-through dark:bg-slate-800',
  // Question bank item lifecycle
  draft: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
  in_review: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  approved: 'bg-warm-200 text-warm-800',
  published: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
  retired: 'bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-400',
};

const ROLE_STYLES = {
  super_admin: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
  admin: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  org_admin: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400',
  editor: 'bg-warm-200 text-warm-800',
  trainer: 'bg-teal-50 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400',
  // Deprecated — kept so legacy rows still render with a sensible colour
  editor_trainer: 'bg-warm-200 text-warm-800',
};

const LABELS = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  completed: 'Completed',
  failed: 'Failed',
  expired: 'Expired',
  draft: 'Draft',
  in_review: 'In Review',
  approved: 'Approved',
  published: 'Published',
  retired: 'Retired',
  super_admin: 'Super Admin',
  admin: 'Admin',
  org_admin: 'Org Admin',
  editor: 'Editor',
  trainer: 'Trainer',
  editor_trainer: 'Editor / Trainer',  // legacy
};

export function LumynBadge({ variant, type = 'status', size = 'md', className }) {
  const styles = type === 'role' ? ROLE_STYLES : STATUS_STYLES;
  const style = styles[variant] || STATUS_STYLES.not_started;
  const label = LABELS[variant] || variant;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs',
        style,
        className,
      )}
      data-testid={`badge-${variant}`}
    >
      {label}
    </span>
  );
}
